export default __webpack_public_path__ + "static/media/property_664.0cb09fb3.png";